import { useEffect } from 'react';
import { v4 as uuidv4 } from 'uuid';

import { KtuinProductForm } from '@/components/modules/Application/components/Cart/KtuinCart/components/KtuinProductForm';
import { useApplicationContext } from '@/contexts/ApplicationContext/ApplicationContext';

export const KtuinCart = () => {
  const {
    state: { orderReference1, checkoutSessionId },
    actions: { updateApplicationContext },
  } = useApplicationContext();

  useEffect(() => {
    // Set random order reference1 if not set
    if (!orderReference1) {
      updateApplicationContext({
        orderReference1: uuidv4().split('-')[4],
      });
    }
  }, []);

  return (
    <div key={`ktuin-cart-${checkoutSessionId}`}>
      <KtuinProductForm />
    </div>
  );
};
